import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import moment from "moment";
import util from "../util/util";
import LoadingIndicatorText from "../loading-indicator/loading-indicator-text";

const jQuery = window.jQuery;

export default function CampaignListTable(props) {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered table-hover">
        <colgroup>
          <col style={{ width: `1%` }}></col>
          <col style={{ width: `70%` }}></col>
          <col style={{ width: `9%` }}></col>
          <col style={{ width: `20%` }}></col>
        </colgroup>
        <thead>
          <tr>
            <th>#</th>
            <th>{renderSortLink(`name`, `Campaign`)}</th>
            <th>Total Pods</th>
            <th>{renderSortLink(`-created`, `Date Created`)}</th>
          </tr>
        </thead>
        <tbody>{renderCampaignRows(props.campaigns)}</tbody>
      </table>
    </div>
  );

  // three options for display (loading, no results, results);
  function renderCampaignRows(campaigns = false) {
    if (campaigns.length === 0) {
      return (
        <tr>
          <td colSpan="4">
            <LoadingIndicatorText />
          </td>
        </tr>
      );
    } else if (campaigns === false) {
      return (
        <tr>
          <td>
            <strong>0</strong>
          </td>
          <td colSpan="3">{util.zeroCampaignsMessage}</td>
        </tr>
      );
    } else {
      return campaigns.map((campaign, index) => {
        return index < util.campaignResultsPerPage ? (
          <tr key={index}>
            <td>
              <strong>
                {util.returnLineNumber(
                  props.currentPage,
                  util.campaignResultsPerPage,
                  index
                )}
              </strong>
            </td>
            <td>
              <Link to={util.returnCampaignDetailUrl(campaign.id)}>
                {campaign.name}
              </Link>
            </td>
            <td>{campaign.pod_count}</td>
            <td>{moment(campaign.created).format(util.dateFormatHumanLong)}</td>
          </tr>
        ) : null;
      });
    }
  }

  // display table header sort links;
  function renderSortLink(sortValue, sortDisplay) {
    const className = util.returnSortClass(sortValue, props.sort);
    const newSortValue = util.returnSortValue(sortValue, props.sort);
    const queryStringObject = props.queryString
      ? jQuery.deparam(props.queryString.replace(`?`, ``))
      : {};

    // add the new sort value to the querystring object;
    queryStringObject.sort = newSortValue;

    return (
      <Link
        to={`${util.returnCampaignListUrl()}?${jQuery.param(
          queryStringObject
        )}`}
        className={className}
      >
        {sortDisplay}
        <i className="fa fa-sort-desc" aria-hidden="true"></i>
        <i className="fa fa-sort-asc" aria-hidden="true"></i>
      </Link>
    );
  }
}

CampaignListTable.propTypes = {
  campaigns: PropTypes.oneOfType([
    // campaign data to display;
    PropTypes.array,
    PropTypes.bool
  ]),
  currentPage: PropTypes.number, // used to calc the # in the TABLE;
  queryString: PropTypes.string, // query string to add to sort links;
  sort: PropTypes.string // currently sorting campaigns by;
};
